import React from 'react';
import { PROJECT_TYPES } from '../../../services/projectsAPI';

function ReviewStep({ formData, onEditStep }) {
  return (
    <div className="space-y-6 fade-in">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">確認專案資訊</h2>
        <p className="text-gray-600">請檢查所有設定是否正確</p>
      </div>

      {/* Review Cards */}
      <div className="space-y-4">
        {/* Basic Info */}
        <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-gray-900 flex items-center">
              <span className="text-2xl mr-2">📋</span>
              基本資訊
            </h3>
            <button
              type="button"
              onClick={() => onEditStep(1)}
              className="text-sm text-purple-600 hover:text-purple-700"
            >
              編輯
            </button>
          </div>
          <dl className="space-y-2">
            <div className="flex">
              <dt className="w-24 text-sm text-gray-600">名稱:</dt>
              <dd className="text-sm text-gray-900 font-medium">{formData.name || '未設定'}</dd>
            </div>
            <div className="flex">
              <dt className="w-24 text-sm text-gray-600">代碼:</dt>
              <dd className="text-sm text-gray-900">{formData.code || '自動生成'}</dd>
            </div>
            <div className="flex">
              <dt className="w-24 text-sm text-gray-600">類型:</dt>
              <dd className="text-sm text-gray-900">
                {PROJECT_TYPES.find(t => t.value === formData.project_type)?.label}
              </dd>
            </div>
            {formData.description && (
              <div className="flex">
                <dt className="w-24 text-sm text-gray-600">描述:</dt>
                <dd className="text-sm text-gray-900">{formData.description}</dd>
              </div>
            )}
          </dl>
        </div>

        {/* Time Scope */}
        <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-semibold text-gray-900 flex items-center">
              <span className="text-2xl mr-2">📅</span>
              時間範圍
            </h3>
            <button
              type="button"
              onClick={() => onEditStep(2)}
              className="text-sm text-purple-600 hover:text-purple-700"
            >
              編輯
            </button>
          </div>
          <dl className="space-y-2">
            <div className="flex">
              <dt className="w-24 text-sm text-gray-600">年份:</dt>
              <dd className="text-sm text-gray-900 font-medium">{formData.time_scope.year}</dd>
            </div>
            {formData.project_type === 'quarterly' && formData.time_scope.quarter && (
              <div className="flex">
                <dt className="w-24 text-sm text-gray-600">季度:</dt>
                <dd className="text-sm text-gray-900">Q{formData.time_scope.quarter}</dd>
              </div>
            )}
            {formData.project_type === 'semi-annual' && formData.time_scope.half && (
              <div className="flex">
                <dt className="w-24 text-sm text-gray-600">半年:</dt>
                <dd className="text-sm text-gray-900">H{formData.time_scope.half}</dd>
              </div>
            )}
            {(formData.project_type === 'ad-hoc' || formData.project_type === 'campaign') && (
              <>
                <div className="flex">
                  <dt className="w-24 text-sm text-gray-600">開始:</dt>
                  <dd className="text-sm text-gray-900">{formData.time_scope.start_date}</dd>
                </div>
                <div className="flex">
                  <dt className="w-24 text-sm text-gray-600">結束:</dt>
                  <dd className="text-sm text-gray-900">{formData.time_scope.end_date}</dd>
                </div>
              </>
            )}
            {formData.budget.total > 0 && (
              <div className="flex">
                <dt className="w-24 text-sm text-gray-600">預算:</dt>
                <dd className="text-sm text-gray-900">
                  {formData.budget.total.toLocaleString()} {formData.budget.currency}
                </dd>
              </div>
            )}
          </dl>
        </div>

      </div>
    </div>
  );
}

export default ReviewStep;
